import React from "react";
import ReactDOM from "react-dom";
import QuestionHeader from "components/test/view/QuestionHeader.jsx";
import QuestionText from "components/test/view/QuestionText.jsx";
import QuestionImages from "components/test/view/QuestionImages.jsx";
import SingleAnswerOptions from "components/test/view/SingleAnswerOptions.jsx";
import MultipleAnswerOptions from "components/test/view/MultipleAnswerOptions.jsx";
import NumericalAnswerComponent from "components/test/view/NumericalAnswerComponent.jsx";
import QuestionFooter from "components/test/view/QuestionFooter.jsx";

import QuestionTextInput from "components/test/view/QuestionTextInput.jsx";
import SingleAnswerQuestionChoices from "components/lov/SingleAnswerQuestionChoices";
import MultipleAnswerQuestionChoices from "components/lov/MultipleAnswerQuestionChoices";

import MatrixGridAnswerComponent from "components/test/view/MatrixGridAnswerComponent.jsx";
import MatrixGridKeyComponent from "components/test/view/MatrixGridKeyComponent.jsx";
import MatrixGridListsComponent from "components/test/view/MatrixGridListsComponent.jsx";

export default class TestQuestionsContainer extends React.Component {
  componentDidMount() {
    if (window.MathJax)
      window.MathJax.Hub.Queue([
        "Typeset",
        window.MathJax.Hub,
        ReactDOM.findDOMNode(this)
      ]);
  }

  componentDidUpdate() {
    if (window.MathJax)
      window.MathJax.Hub.Queue([
        "Typeset",
        window.MathJax.Hub,
        ReactDOM.findDOMNode(this)
      ]);
  }

  safeParseJSON(value, fallback = []) {
    try {
      if (!value) return fallback;
      const parsed = typeof value === "string" ? JSON.parse(value) : value;
      return parsed || fallback;
    } catch (e) {
      console.error("Invalid JSON in TestQuestionsContainer:", value, e);
      return fallback;
    }
  }

  asArray(value) {
    return Array.isArray(value) ? value : [];
  }

  safeBlockItem(item) {
    return Array.isArray(item) ? item : ["", ""];
  }

  convNumbersToLetters(int) {
    if (int === undefined || int === null || int === "") return "";
    return String.fromCharCode(64 + parseInt(int));
  }

  convMAQDataNumbersToLetters(ansNumberArray) {
    if (!Array.isArray(ansNumberArray) || !Array.isArray(ansNumberArray[0])) {
      return [];
    }

    var ansLetterArray = [];
    for (var i in ansNumberArray[0]) {
      ansLetterArray.push(
        String.fromCharCode(64 + parseInt(ansNumberArray[0][i]))
      );
    }
    return ansLetterArray;
  }

  getInlineComponentStyles(data, index) {
    if (!Array.isArray(data) || data.length < 1) {
      return false;
    }

    if (
      data[index] &&
      data[index][1] &&
      typeof data[index][1] === "string" &&
      data[index][1].includes("inline")
    ) {
      return true;
    }

    if (
      index > 0 &&
      data[index - 1] &&
      data[index - 1][1] &&
      typeof data[index - 1][1] === "string" &&
      data[index - 1][1].includes("inline")
    ) {
      return true;
    }

    return false;
  }

  render() {
    const {
      testData,
      nextQ,
      prevQ,
      lastQ,
      firstQ,
      handleAnswerChange,
      handleMultipleAnswerChange,
      handleMarkForReviewChange,
      handleClearResponse,
      isEditMode,
      handleEditTestData,
      handleSaveQuestionData,
      handleDiscardQuestionData,
      handleClearQuestionData,
      questionSavedIndicator,
      handleAddTextComponent,
      handleAddListComponent,
      handleRemoveListComponent,
      handleRemoveTextComponent,
      handlePasteEvent,
      handleRemoveImageComponent,
      handleTestModeChange,
      isTestScheduled,
      isFetchQuestionsView,
      handleImageFileUpload,
      noQuestionFooter,
      handleClearKey
    } = this.props;

    const safeTestData = testData || {};
    const questionContent =
      safeTestData["question_content"] && typeof safeTestData["question_content"] === "object"
        ? safeTestData["question_content"]
        : {};

    const patternShortName = safeTestData["pattern_short_name"];

    const rawQuestionBlocks = this.asArray(questionContent.question);
    const rawPassageBlocks = this.asArray(questionContent.passage);

    const questionBlocks =
      rawQuestionBlocks.length > 0
        ? rawQuestionBlocks
        : isEditMode && !isTestScheduled
          ? [["", ""]]
          : [];

    const passageBlocks =
      rawPassageBlocks.length > 0
        ? rawPassageBlocks
        : isEditMode && !isTestScheduled && patternShortName === "PASSAGE"
          ? [["", ""]]
          : [];

    const optionBlocks = this.asArray(questionContent.options);
    const list1 = this.asArray(questionContent.list1);
    const list2 = this.asArray(questionContent.list2);

    const parsedKey = this.asArray(this.safeParseJSON(safeTestData["key"], []));
    const parsedSolution = this.asArray(
      this.safeParseJSON(safeTestData["solution"], [])
    );

    const hasQuestionContent = !!safeTestData["question_content"];

    const singleAnswerKey =
      parsedKey.length > 0 && Array.isArray(parsedKey[0]) && parsedKey[0].length > 0
        ? this.convNumbersToLetters(parsedKey[0][0])
        : "";

    const numericalAnswerKey =
      parsedKey.length > 0 && Array.isArray(parsedKey[0]) && parsedKey[0].length > 0
        ? parsedKey[0][0]
        : "";

    return (
      <div style={{ paddingBottom: "50px" }}>
        {/*FOR THE PAGE TO BE SCROLLABLE WITHOUT FOOTER OCCLUSION*/}

        <QuestionHeader
          number={safeTestData["question_no"]}
          pattern={safeTestData["pattern_name"]}
          subject={safeTestData["subject_name"]}
          positiveMarks={safeTestData["positive_marks"]}
          negativeMarks={safeTestData["negative_marks"]}
          partialMarks={safeTestData["partial_marks"]}
          isEditMode={isEditMode}
          handleSaveQuestionData={handleSaveQuestionData}
          handleDiscardQuestionData={handleDiscardQuestionData}
          handleClearQuestionData={handleClearQuestionData}
          questionSavedIndicator={questionSavedIndicator}
          handleTestModeChange={handleTestModeChange}
          {...this.props}
        />

        <hr />

        {hasQuestionContent && patternShortName === "PASSAGE" && !isEditMode && (
          <h4
            style={{
              marginLeft: "15px",
              paddingTop: "4px",
              fontWeight: "600",
              fontSize: "16px"
            }}
          >
            Passage
          </h4>
        )}

        {hasQuestionContent && patternShortName === "PASSAGE" && (
          <div style={{ paddingLeft: "15px", paddingRight: "15px" }}>
            {passageBlocks.map((rawItem, index) => {
              const item = this.safeBlockItem(rawItem);

              return (
                <React.Fragment key={index}>
                  {isEditMode && !isTestScheduled ? (
                    <React.Fragment>
                      <h4
                        style={{
                          marginLeft: "20px",
                          paddingTop: "10px",
                          fontWeight: "600",
                          fontSize: "18px"
                        }}
                      >
                        Passage
                      </h4>

                      <QuestionTextInput
                        text={item[0]}
                        name={"passage_" + index + "_0"}
                        handleEditTestData={handleEditTestData}
                        handleAddTextComponent={handleAddTextComponent}
                        handleRemoveTextComponent={handleRemoveTextComponent}
                        handlePasteEvent={handlePasteEvent}
                        handleImageFileUpload={handleImageFileUpload}
                        rows="3"
                      />
                    </React.Fragment>
                  ) : item[0] ? (
                    <QuestionText text={item[0]} />
                  ) : null}

                  {item[1] ? (
                    <QuestionImages
                      src={item[1]}
                      name={"passage_" + index + "_1"}
                      isEditMode={isEditMode && !isTestScheduled}
                      handleRemoveImageComponent={handleRemoveImageComponent}
                    />
                  ) : null}
                </React.Fragment>
              );
            })}
          </div>
        )}

        {hasQuestionContent && patternShortName === "PASSAGE" && !isEditMode && (
          <h4
            style={{
              marginLeft: "15px",
              paddingTop: "4px",
              fontWeight: "600",
              fontSize: "16px"
            }}
          >
            Question
          </h4>
        )}

        {hasQuestionContent && questionBlocks.length === 0 && !isEditMode ? (
          <div
            style={{
              margin: "15px",
              padding: "12px",
              border: "1px solid #d9534f",
              borderRadius: "4px",
              backgroundColor: "#fff5f5",
              color: "#a94442"
            }}
          >
            Question content is missing or invalid for this question. Please switch to edit mode and add the question content.
          </div>
        ) : null}

        {hasQuestionContent && questionBlocks.length > 0 && (
          <div style={{ paddingLeft: "15px", paddingRight: "15px" }}>
            {questionBlocks.map((rawItem, index) => {
              const item = this.safeBlockItem(rawItem);

              return (
                <React.Fragment key={index}>
                  {isEditMode && !isTestScheduled ? (
                    <React.Fragment>
                      <h4
                        style={{
                          marginLeft: "20px",
                          paddingTop: "10px",
                          fontWeight: "600",
                          fontSize: "18px"
                        }}
                      >
                        Question
                      </h4>

                      <QuestionTextInput
                        text={item[0]}
                        name={"question_" + index + "_0"}
                        handleEditTestData={handleEditTestData}
                        handleAddTextComponent={handleAddTextComponent}
                        handleRemoveTextComponent={handleRemoveTextComponent}
                        handlePasteEvent={handlePasteEvent}
                        handleImageFileUpload={handleImageFileUpload}
                        rows="3"
                      />
                    </React.Fragment>
                  ) : item[0] ? (
                    <QuestionText text={item[0]} />
                  ) : null}

                  {item[1] ? (
                    <QuestionImages
                      src={item[1]}
                      name={"question_" + index + "_1"}
                      isEditMode={isEditMode && !isTestScheduled}
                      handleRemoveImageComponent={handleRemoveImageComponent}
                    />
                  ) : null}
                </React.Fragment>
              );
            })}
          </div>
        )}

        <div style={{ paddingBottom: "20px" }}></div>

        {hasQuestionContent &&
        (patternShortName === "MM" ||
          (patternShortName === "MCQ" &&
            list1.length > 0 &&
            list2.length > 0)) ? (
          <MatrixGridListsComponent
            {...this.props}
            list1={list1}
            list2={list2}
            handleAddListComponent={handleAddListComponent}
            handleRemoveListComponent={handleRemoveListComponent}
            isEditMode={isEditMode}
          />
        ) : null}

        {hasQuestionContent &&
        (patternShortName === "MCQ" || patternShortName === "PASSAGE") ? (
          <SingleAnswerOptions
            {...this.props}
            answer={""}
            AnswerKey={singleAnswerKey}
            options={optionBlocks}
            answerChanged={handleAnswerChange}
            isEditMode={isEditMode && !isTestScheduled}
            handleEditTestData={handleEditTestData}
            handlePasteEvent={handlePasteEvent}
            handleRemoveImageComponent={handleRemoveImageComponent}
            handleImageFileUpload={handleImageFileUpload}
          />
        ) : null}

        {hasQuestionContent && patternShortName === "MAQ" ? (
          <MultipleAnswerOptions
            {...this.props}
            answer={""}
            AnswerKey={this.convMAQDataNumbersToLetters(parsedKey)}
            options={optionBlocks}
            answerChanged={handleMultipleAnswerChange}
            isEditMode={isEditMode && !isTestScheduled}
            handleEditTestData={handleEditTestData}
            handlePasteEvent={handlePasteEvent}
            handleRemoveImageComponent={handleRemoveImageComponent}
            handleImageFileUpload={handleImageFileUpload}
          />
        ) : null}

        {!isEditMode &&
        hasQuestionContent &&
        (patternShortName === "NUMERICAL" || patternShortName === "INTEGER") ? (
          <NumericalAnswerComponent
            {...this.props}
            answer={""}
            AnswerKey={numericalAnswerKey}
            patternType={patternShortName}
            options={optionBlocks}
            answerChanged={handleEditTestData}
          />
        ) : null}

        {!isEditMode && hasQuestionContent && patternShortName === "MM" ? (
          <MatrixGridAnswerComponent
            {...this.props}
            answer={""}
            showSolutions={true}
            AnswerKey={parsedKey}
            list1={list1}
            list2={list2}
            answerChanged={handleEditTestData}
          />
        ) : null}

        {parsedKey.length > 0 &&
        isEditMode &&
        (patternShortName === "MCQ" || patternShortName === "PASSAGE") ? (
          <div style={{ margin: "20px" }}>
            <h4
              style={{
                marginLeft: "20px",
                paddingTop: "10px",
                fontWeight: "600",
                fontSize: "18px"
              }}
            >
              Key
            </h4>

            {parsedKey.map((rawItem, index) => {
              const item = Array.isArray(rawItem) ? rawItem : [];

              return (
                <div
                  key={index}
                  style={{ marginLeft: "20px", paddingTop: "10px" }}
                >
                  <SingleAnswerQuestionChoices
                    name={"key_" + index + "_0"}
                    formControlWidth="20%"
                    value={item[0] ? item[0] : ""}
                    change={handleEditTestData}
                    handleClearKey={handleClearKey}
                  />
                </div>
              );
            })}
          </div>
        ) : null}

        {parsedKey.length > 0 && isEditMode && patternShortName === "MAQ" ? (
          <div style={{ margin: "20px" }}>
            <h4
              style={{
                marginLeft: "20px",
                paddingTop: "10px",
                fontWeight: "600",
                fontSize: "18px"
              }}
            >
              Key
            </h4>

            {parsedKey.map((item, index) => (
              <div
                key={index}
                style={{ marginLeft: "20px", paddingTop: "10px" }}
              >
                <MultipleAnswerQuestionChoices
                  name={"key_" + index + "_0"}
                  formControlWidth="20%"
                  value={Array.isArray(item) ? item : []}
                  change={handleEditTestData}
                  handleClearKey={handleClearKey}
                />
              </div>
            ))}
          </div>
        ) : null}

        {parsedKey.length > 0 &&
        isEditMode &&
        (patternShortName === "NUMERICAL" || patternShortName === "INTEGER") ? (
          <div style={{ margin: "20px" }}>
            <h4
              style={{
                marginLeft: "20px",
                paddingTop: "10px",
                fontWeight: "600",
                fontSize: "18px"
              }}
            >
              Key
            </h4>

            {parsedKey.map((rawItem, index) => {
              const item = Array.isArray(rawItem) ? rawItem : [];

              return (
                <div key={index} style={{ width: "25%" }}>
                  <QuestionTextInput
                    text={item[0] ? item[0] : ""}
                    name={"key_" + index + "_0"}
                    handleEditTestData={handleEditTestData}
                    rows="1"
                    isSingleComponent={true}
                    noImageAttachment={true}
                  />
                </div>
              );
            })}
          </div>
        ) : null}

        {parsedKey.length > 0 &&
        isEditMode &&
        hasQuestionContent &&
        patternShortName === "MM" ? (
          <div style={{ margin: "20px" }}>
            <h4
              style={{
                marginLeft: "20px",
                paddingTop: "10px",
                fontWeight: "600",
                fontSize: "18px"
              }}
            >
              Key
            </h4>

            {list1.map((item, index) => (
              <div
                key={index}
                style={{ marginLeft: "20px", paddingTop: "10px" }}
              >
                <p style={{ fontWeight: "400" }}>
                  {"Part " + String.fromCharCode(65 + index)}
                </p>

                <MatrixGridKeyComponent
                  name={"key_" + index + "_0"}
                  formControlWidth="20%"
                  value={Array.isArray(parsedKey[index]) ? parsedKey[index] : []}
                  change={handleEditTestData}
                  list2={list2}
                />
              </div>
            ))}
          </div>
        ) : null}

        {parsedSolution.length > 0 ? (
          <div style={{ margin: "20px" }}>
            <h4
              style={{
                marginLeft: "20px",
                paddingTop: "10px",
                fontWeight: "600",
                fontSize: "18px",
                marginBottom: "20px"
              }}
            >
              Solution
            </h4>

            {parsedSolution.map((rawItem, index) => {
              const item = this.safeBlockItem(rawItem);

              return (
                <div key={index}>
                  {isEditMode ? (
                    <QuestionTextInput
                      text={item[0]}
                      name={"solution_" + index + "_0"}
                      handleEditTestData={handleEditTestData}
                      handleAddTextComponent={handleAddTextComponent}
                      handleRemoveTextComponent={handleRemoveTextComponent}
                      handlePasteEvent={handlePasteEvent}
                      handleImageFileUpload={handleImageFileUpload}
                      rows="3"
                    />
                  ) : item[0] ? (
                    <QuestionText text={item[0]} />
                  ) : null}

                  {item[1] ? (
                    <QuestionImages
                      src={item[1]}
                      name={"solution_" + index + "_1"}
                      isEditMode={isEditMode}
                      handleRemoveImageComponent={handleRemoveImageComponent}
                      backgroundColor="transparent"
                    />
                  ) : null}
                </div>
              );
            })}
          </div>
        ) : null}

        {hasQuestionContent && !noQuestionFooter ? (
          <QuestionFooter
            {...this.props}
            nextQ={nextQ}
            prevQ={prevQ}
            lastQ={lastQ}
            firstQ={firstQ}
            markedForReview={false}
            markForReviewChanged={handleMarkForReviewChange}
            handleClearResponse={handleClearResponse}
            isFetchQuestionsView={isFetchQuestionsView}
          />
        ) : null}
      </div>
    );
  }
}
